/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import { connect } from 'react-redux';

import './Home.scss';

/**

first page to render when user logs in

@param

**/

export class Home extends Component {
    
    componentDidMount() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);     
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    render () {
        return (
            <div className="home-page content">
                <section className="home-welcome-panel" aria-label="CTBIDS Seller home">
                    <img
                        src={`${process.env.PUBLIC_URL}/static/logo/CaringTransitions_CTBidsLogo.png`}
                        alt="Caring Transitions and CTBids"
                        className="home-brand-lockup"
                    />
                    <h1 className='text-bold'>Welcome to CTBids Seller</h1>
                    <p>Manage your locations, sales, buyers, invoices and more<br className="d-none d-md-block" /> - all in one place.</p>
                </section>
            </div>
        );
    }
}

export default connect(state => state)(Home);
